module.exports = __webpack_public_path__ + "static/fv-page-fbc07b7d159aaa28021e385e4e552a61.jpg";